module.exports = __webpack_public_path__ + "media/images/badge-making-active-110e9958de4e9e55ac20a2e39d19954d.svg";